var $ = require('jQuery');
var Component = require('../../Component');
var template = require('../../../template/contactinfo-window.html');
var utils = require('../../../global/utils');
var dispatcher = require('.././../../global/dispatcher');
var isPhone = utils.isPhone;
var isWechat = utils.isWechat;
var ActionType = require('./../../../constant/ActionType');
var isEmpty = utils.isEmpty;

var ContactInfoWindow = function (options) {
    (function (self) {
        var defaults = {
            template: template
        };
        $.extend(defaults, options);
        Component.call(self, defaults);
    })(this);

    (function (self) {
        self._element.click(function(e){
            var _target = $(e.target);
            if(_target.hasClass('window-contactinfo-bg') || _target.hasClass('window-contactinfo-contain')){
                e.stopPropagation();
            }
            var contactinfo_content = self._element;
            var contactinfo_bg = self._element.find(".window-contactinfo-bg");
            var contactinfo_tel = contactinfo_content.find('#contactinfo_tel');
            var contactinfo_wechat = contactinfo_content.find('#contactinfo_wechat');
            var contactinfo_err =  contactinfo_content.find('.window--contactinfo-info-error');
            //忽略
            if(_target.hasClass('cancel_contactinfo')){
                contactinfo_tel.css('border-color', '#F0F0F0');
                contactinfo_wechat.css('border-color', '#F0F0F0');
                contactinfo_err.css('visibility', 'hidden');
                contactinfo_content.hide();
                contactinfo_bg.hide();
            }
            //关闭
            if(_target.hasClass('window-contactinfo-title-x')){
                contactinfo_tel.css('border-color', '#F0F0F0');
                contactinfo_wechat.css('border-color', '#F0F0F0');
                contactinfo_err.css('visibility', 'hidden');
                contactinfo_content.hide();
                contactinfo_bg.hide();
            }
            // 确定发送 unbind('click')
            if (_target.hasClass('submit_contactinfo')) {
                e.stopPropagation();
                var errText;
                var contactinfoTel = contactinfo_tel[0].value;
                var contactinfoWechat = contactinfo_wechat[0].value;
                var phoneText = self._data.selfContactinfoTel;
                var wechatText = self._data.selfContactinfoWechat;
                var currentcontact = self._data.currentcontact || {};
                console.log('-00000',wechatText)
                //判断手机号、微信号是否格式正确
                //1、两种都没有填写，给提示
                if (!contactinfoTel && !contactinfoWechat) {
                  errText = '请至少填写一项联系方式';
                  contactinfo_err.text(errText);
                  contactinfo_err.css('visibility', 'visible');
                  return
                }
                //2、手机号填写但填写错误微信号填写或填写错误
                var contactinfoTelIsPhone = phoneText === contactinfoTel?true: isPhone(contactinfoTel);
                var contactinfoWechatIsWechat= wechatText === contactinfoWechat ?true:isWechat(contactinfoWechat);
                if((contactinfoTel!=='' && !contactinfoTelIsPhone) || (contactinfoWechat!=='' && !contactinfoWechatIsWechat)){
                  errText='联系方式有误，请重新填写'
                  contactinfo_err.text(errText);
                  contactinfo_err.css('visibility', 'visible');
                  if (!contactinfoTelIsPhone && !contactinfoWechatIsWechat) {//手机号、微信号格式错误
                    contactinfo_tel.css('border-color', 'red');
                    contactinfo_wechat.css('border-color', 'red')
                  } else if (!contactinfoWechatIsWechat) {//微信号错误
                    contactinfo_wechat.css('border-color', 'red');
                    contactinfo_tel.css('border-color', '#F0F0F0');
                  } else if (!contactinfoTelIsPhone) {//手机号
                    contactinfo_tel.css('border-color', 'red');
                    contactinfo_wechat.css('border-color', '#F0F0F0');
                  }
                  return
                }
                let sendContactinfo = {
                  other_user_id: currentcontact.user_id || '',
                  other_user_source: currentcontact.user_source || '',
                  tel: phoneText === contactinfoTel?'':contactinfoTel ,
                  wechat: wechatText === contactinfoWechat?'': contactinfoWechat,
                  is_wechat_constant: (wechatText === contactinfoWechat && wechatText !=='' && contactinfoWechat !== '') || (wechatText === contactinfoWechat && wechatText =='' && contactinfoWechat == '') ? true:false,
                  is_tel_constant: (phoneText === contactinfoTel && phoneText !== '' &&  contactinfoTel!== '') || (phoneText === contactinfoTel && phoneText == '' &&  contactinfoTel== '') ?true:false,
                }
                dispatcher.dispatch({
                    type: ActionType.SEND_CONTACTINFO,
                    data: sendContactinfo
                });
                contactinfo_tel.css('border-color','#F0F0F0');
                contactinfo_wechat.css('border-color','#F0F0F0');
                contactinfo_err.css('visibility', 'hidden');
                self.hide();
            }
          });
    })(this);
};
ContactInfoWindow.prototype = Object.create(Component.prototype);
ContactInfoWindow.prototype.render = function () {
    var $element = this.getElement();
    var contactinfo_content = $element;
    var title = contactinfo_content.find('.window-contactinfo-title-text');
    var contactinfo_tel = contactinfo_content.find('#contactinfo_tel');
    var window_contactinfo_btn= contactinfo_content.find('.window-contactinfo-btn');
    var contactinfo_wechat = contactinfo_content.find('#contactinfo_wechat');
    var my_sumbit_btn= contactinfo_content.find('.submit_contactinfo');
    var my_cancel_btn= contactinfo_content.find('.cancel_contactinfo');
    var data = this._data;
    var text = data.text ? data.text : '';
    //title
    title.text(text);
    //头像
    contactinfo_content.find('.window-contactinfo-header-avatar').attr('src', data.avatarInfo)
    //名称
    contactinfo_content.find('.window-contactinfo-header-name').text(data.nameInfo);
    //提示
    contactinfo_content.find('.window-contactinfo-point').text('提示:您发送的联系方式只会提供给索要方，不做他用，请放心填写。您可只填入一项信息，格式正确即可发送，如填入两项信息，则要保证格式全部正确才可发送。');
    //电话微信展示
    contactinfo_tel[0].value = data.selfContactinfoTel;
    contactinfo_wechat[0].value = data.selfContactinfoWechat;
    //按钮配置
    my_sumbit_btn.text('确定发送')
    if (text === '我的联系方式') {//从我的入口进入
        if (window_contactinfo_btn.hasClass('card_contactinfo')) {
        window_contactinfo_btn.removeClass('card_contactinfo').addClass('my_contactinfo')
        } else {
        window_contactinfo_btn.addClass('my_contactinfo')
        }

    } else {//从邀请卡片进入
        if (window_contactinfo_btn.hasClass('my_contactinfo')) {
        window_contactinfo_btn.removeClass('my_contactinfo').addClass('card_contactinfo')
        } else {
        window_contactinfo_btn.addClass('card_contactinfo')
        }
        my_cancel_btn.text('忽略')
    }
};
ContactInfoWindow.prototype.show = function (text) {
    Component.prototype.show.call(this);
    var $element = this.getElement();
    var contactinfo_content = $element;
    var contactinfo_bg = $element.find(".window-contactinfo-bg");
    contactinfo_content.show();
    contactinfo_bg.show();
};
ContactInfoWindow.prototype.hide = function () {
    Component.prototype.hide.call(this);
    var $element = this.getElement();
    var contactinfo_content = $element;
    var contactinfo_bg = $element.find(".window-contactinfo-bg");
    contactinfo_content.hide();
    contactinfo_bg.hide();
};

module.exports = ContactInfoWindow;
